<template>
  <div class="check-id">
    <h1 class="title">找回密码</h1>
    <div style="width:440px;margin:0 auto;" class="change-loginPass">
      <div>
        <el-form :model="checkInfo" ref="checkInfo" :rules="rules" label-width="100px" class="check-info">
          <el-form-item prop="loginName" label="登录账号">
            <el-input v-model="checkInfo.loginName" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item prop="realName" label="真实姓名">
            <el-input v-model="checkInfo.realName" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" v-if="infoCheck" @click="checkUser">确定</el-button>
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" disabled v-if="!infoCheck" @click="checkUser">确定</el-button>
            <p style="color:#999999" v-if="!infoCheck">您的安全信息设置不全，不能通过该方式找回密码。请联系管理员找回密码</p>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import checkCard from "../.././utils/checkCard";
export default {
  data () {
    const checkIdno = (rule, value, callback) => {
      if (checkCard(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的身份证号码！"));
      }
    }
    return {
      infoCheck: true,
      checkInfo: {
        loginName: '',
        realName: '',
      },
      rules: {
        loginName: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          { validator: checkIdno, trigger: "blur" }
        ],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          { max: 20, message: "最多20个字符", trigger: "blur" }
        ]
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    checkUser () {
      this.$refs['checkInfo'].validate(valid => {
        if(valid){
          this.$ajax.post('/comuser-service/Account/getUserInfoByNameAndRealName',this.postData({
            loginName: this.checkInfo.loginName,
            realName: this.checkInfo.realName
          })).then(res => {
            if ((res.code === '200')) {
              sessionStorage.userUuid = res.data.id
              sessionStorage.loginName = res.data.loginName
              this.$message({
                message: "信息验证成功",
                type: "success"
              })
              this.$ajax.post("/comuser-service/Account/seeAccount",this.postData({
                id: sessionStorage.userUuid
              })).then(res => {
                if (!res.data.tbAccount.mobile && !res.data.tbAccount.emailAddress && !res.data.tbAccount.question) {
                  this.infoCheck = false
                } else {
                  this.infoCheck = true
                  setTimeout(() => {
                    sessionStorage.step = 'idChecked'
                    this.$router.push('/FindPass/FindPassword')
                  }, 2000)
                }
              });
            } else {
              this.$message.error(res.data)
            }
          })
        }
      })
      
    }
  }
}
</script>
<style lang="scss">
.check-id {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
    margin-bottom:90px;
  }
  .check-info {
    margin-bottom:33px;
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 340px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/findPass/checkIdInfo.vue